/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefApiKeyData } from '../../models/api-def-api-key-data';

export interface OrganizationsUpdateApiKey$Params {
  organizationId: string;
  apiKeyId: string;
      body: {

/**
 * New name for the API key
 */
'name'?: string;

/**
 * List of project IDs to apply to
 */
'projects'?: Array<string>;

/**
 * New expiration date
 */
'expiresAt'?: string | null;
}
}

export function organizationsUpdateApiKey(http: HttpClient, rootUrl: string, params: OrganizationsUpdateApiKey$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefApiKeyData>> {
  const rb = new RequestBuilder(rootUrl, organizationsUpdateApiKey.PATH, 'patch');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('apiKeyId', params.apiKeyId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiDefApiKeyData>;
    })
  );
}

organizationsUpdateApiKey.PATH = '/organizations/{organizationId}/api-keys/{apiKeyId}';
